let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ky0u2")).then(() => parcelRequire('1l7RQ'));